import { useMemo } from 'react';

import { config } from '../../../config/config';

import { useCurrentJurisdiction } from './use-current-jurisdiction';

export function useRegistrationAge() {
    const ageConfig = config.MINIMUM_REGISTRATION_AGE_JURISDICTION;
    const currentJusistiction = useCurrentJurisdiction() as keyof typeof ageConfig;

    const age = ageConfig[currentJusistiction] ?? ageConfig.UKGC;

    return useMemo(() => {
        return { minimumAge: age };
    }, [age]);
}
